/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {APP_BASE_HREF} from '@angular/common';
import {BrowserModule, Title} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule} from '@angular/core';
import {HttpClientModule, HttpClient} from '@angular/common/http';
import {CoreModule} from './@core/core.module';
// import { AngularSvgIconModule } from 'angular-svg-icon';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {ThemeModule} from './@theme/theme.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NbAuthModule} from '@nebular/auth';
import {NbEmailPassAuthProvider} from './@theme/components/auth/email-pass-auth.provider';
import {BrowserXhr} from '@angular/http';
import {CustExtBrowserXhr} from './@core/cust-ext-browser-xhr';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import { LeafletDrawModule } from '@asymmetrik/ngx-leaflet-draw';
import {DndModule} from 'ng2-dnd';
// import {BootstrapSwitchModule} from 'angular2-bootstrap-switch';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

import {AUTH_CONFIG} from './configs/auth.config';

import {AdminRouteGuard} from './admin-route-guard';
import {UserRouteGuard} from './user-route-guard';
import {RedirectComponent} from './redirect/redirect.component';
import { ActionService } from './@core/data/action.service';
import { ProjectsService } from './@core/data/projects.service';
import { AppCheckService } from './@core/data/app-check.service';
import { SubscriptionService } from './@core/data/subscription.service';
import { PolygonService } from './@core/data/polygon.service';
import { UsersService } from './@core/data/users.service';
import { PolicyService } from './@core/data/policy.service';
import { PermissionsUsersService } from './@core/data/permissions-users.service';
import { DespachoService } from './@core/data/despacho.service';
import { DataService } from './services/data.service';
import { GroupPolygonService } from './@core/data/group-polygon.service';
import { CatStatusCheckService } from './@core/data/cat-status-check.service';
import { InspectClaim } from './@core/data/inspect-claim.service';
import { SucursalService } from './@core/data/sucursal.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'https://server.sinecta.com/api/v1/translations/');
}



@NgModule({
  declarations: [AppComponent, RedirectComponent],
  imports: [
    // AngularSvgIconModule,
    BrowserModule,
    InfiniteScrollModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    LeafletModule.forRoot(),
    LeafletDrawModule.forRoot(),
    DndModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    // BootstrapSwitchModule.forRoot(),
    NbAuthModule.forRoot({
      providers: {
        email: {
          service: NbEmailPassAuthProvider,
          config: AUTH_CONFIG,
        },
      },
      forms: {
        login: {
          redirectDelay: 0,
          provider: 'email',
          showMessages: {
            success: true,
            error: true,
          },
        },
        logout: {
          redirectDelay: 0,
          provider: 'email',
          showMessages: {
            success: true,
            error: true,
          },
        },
        requestPassword: {
          redirectDelay: 0,
          provider: 'email',
          showMessages: {
            success: true,
            error: true,
          },
        },
        resetPassword: {
          redirectDelay: 0,
          provider: 'email',
          showMessages: {
            success: true,
            error: true,
          },
        },
        validation: {
          password: {
            required: true,
          },
          email: {
            required: true,
          },
        },
      },
    }),
  ],
  bootstrap: [AppComponent],
  providers: [
    {provide: BrowserXhr, useClass: CustExtBrowserXhr},
    {provide: APP_BASE_HREF, useValue: '/'},
    NbEmailPassAuthProvider,
    AdminRouteGuard,
    UserRouteGuard,
    Title,
    ActionService,
    ProjectsService,
    AppCheckService,
    SubscriptionService,
    PolygonService,
    UsersService,
    PolicyService,
    PermissionsUsersService,
    DespachoService,
    DataService,
    GroupPolygonService,
    CatStatusCheckService,
    InspectClaim,
    SucursalService,
  ],
  exports: [InfiniteScrollModule,TranslateModule],
})
export class AppModule {}
